import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { ReverseCollectContext } from '../..';

export const ModalAcceptResponsibilityTerms = () => {
  const { Modal, closeModal } = useModal();

  const {
    setDocumentType,
    setHasAcceptResponsibilityTerms,
    openCreateDeclarationModal
  } = useContext(ReverseCollectContext);

  const handleAcceptTerms = () => {
    closeModal();
    setDocumentType('declaration');
    setHasAcceptResponsibilityTerms(true);
    openCreateDeclarationModal();
  };

  const handleRejectTerms = () => {
    setDocumentType('');
    setHasAcceptResponsibilityTerms(false);
    closeModal();
  };

  return (
    <Modal closeFunction={handleRejectTerms}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16
        }}
      >
        <ModalTitle>Termo de Responsabilidade</ModalTitle>

        <ModalText>
          Declaro para os devidos fins, e sob as penas legais que entregamos à
          BRASPRESS TRANSPORTES URGENTES LTDA, os produtos relacionados abaixo,
          para transporte até o destinatário informado nesta declaração. As
          mercadorias são particulares, sem valor comercial e não requer emissão
          de nota fiscal, dada sua natureza ou minha condição de não
          contribuinte. Declaro não haver mercadorias ilegais, visto que o
          conteúdo da mercadoria é inteiramente de responsabilidade do
          contratante.
        </ModalText>

        <Box style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            onClick={handleRejectTerms}
          >
            Cancelar
          </Button>
          <Button type="button" variant="contained" onClick={handleAcceptTerms}>
            Aceitar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
